export enum BillingSystem {
  FORTNOX = "FORTNOX",
  SZAMLAZZ = "SZAMLAZZ",
}
